import { jsx as _jsx } from "react/jsx-runtime";
import { useWidgetContext } from '../../../../hooks/use-widget-context';
import { VoipTextCallDesktop } from './desktop';
import { VoipTextCallMobile } from './mobile';
export const VoipTextCall = ({ text }) => {
    const { platform } = useWidgetContext();
    if (platform === 'mobile')
        return _jsx(VoipTextCallMobile, { text: text });
    return _jsx(VoipTextCallDesktop, { text: text });
};
